import { CreateUserQueryArg } from '../types/query-arg';
import { CreateUserQueryBody } from '../types/query-body';

export const createUserQueryBody = ({
  firstName,
  lastName,
  email,
  roleId,
  organisationId,
  permittedGroups,
}: CreateUserQueryArg): CreateUserQueryBody => ({
  firstName,
  lastName,
  email,
  roleId,
  permittedGroups,
  ...(organisationId ? { organisationId } : {}),
});
